import React, { useState } from "react";
import { Spin, Row, Col, notification, Form } from "antd";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import Button from "../../components/ReportFormGenerator/Button/Button";
import Idame from "../../components/ReportFormGenerator/Idame/Idame";
 import StablePrime from "../../components/Tables/StablePrime";

function TrainingRecords({ setPageHeader }) {
  const [form] = Form.useForm();
  const [FormData, setFormData] = useState(null);
  setPageHeader("Training Records");

  const onFinish = (values) => {
    setFormData(values);
    
  };

  const productionTableStyle = {
    marginTop: "1rem",
    marginBottom: "1rem",
  };

  const Tables = () => {
    if (FormData) {
      return (
        <>
          {FormData ? (
            <div style={productionTableStyle}>
              <StablePrime
                url="/"
                data={FormData}
                identity="Training Records"
              />
            </div>
          ) : (
            <></>
          )}
        </>
      );
    } else {
      return <></>;
    }
  };
  return (
    <>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <Idame
                  // width = {100}
                  form={form}
                  type="name"
                  url="/mdict"
                  urlData={{
                    typ: "TrainingSubjects",
                    subTyp: "idame",
                    includeAll: true,
                  }}
                  idName="trg"
                  idLabel="Training Subjects"
                  idErrorMessage="Please Select Training Subjects"
                  idRequired={true}
                  idPlaceholder="Select Training Subjects"
                  nameName="eame"
                  nameLabel="Training Subjects"
                  nameErrorMessage="Please Select Training Subjects"
                  nameRequired={true}
                  namePlaceholder="Select Training Subjects"
                  defaultIdValue="All"
                  defaultNameValue="All"
                />
              </Col>
            </Row>

            <Row gutter={24} justify="center">
              <Col span={24}>
                <Button
                  marginLeft={"300px"}
                  form={form}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Tables />
    </>
  );
}

export default TrainingRecords;
